import { EventEmitter } from '@angular/core';

const GOOGLE_LOCATE_LBS$ = new EventEmitter<any>();
export default GOOGLE_LOCATE_LBS$;
